import { render, staticRenderFns } from "./StockMovement.vue?vue&type=template&id=014637ea&scoped=true&"
import script from "./StockMovement.vue?vue&type=script&lang=ts&"
export * from "./StockMovement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014637ea",
  null
  
)

export default component.exports